<template>
    <div class="agents-list mx-auto">
        <b-container>
            <b-card class="bg-white">
                <b-breadcrumb class="bg-white mt-2" :items="this.breadcrumb_items"></b-breadcrumb>
                <b-row>
                    <b-col col-md="1">
                        <b-button variant="success" class="mb-2" @click="create">Add Agent</b-button>
                    </b-col>
                </b-row>
                <vue-chunks id="results" ref="test" :items="agents" :columns="3" chunk-class="card-deck mb-5">
                    <template slot-scope="slot">
                        <b-card no-body
                                :img-src="slot.item.image_url !== null ? slot.item.image_url : 'https://forman-group-images.s3.amazonaws.com/no_image_available.jpg'"
                                img-alt="Image"
                                img-top
                                tag="article"
                                style="max-width: 20rem; min-width: 20rem;"
                                class="mb-2 shadow card">
                            <b-card-body>
                                <b-row>
                                    <b-col md="10"><a :href="'/' + slot.item.slug" style="color:black"><h4>{{ slot.item.user.name}}</h4></a></b-col>
                                    <b-col md="2">
                                        <i class="fas fa-pencil-alt fa-lg hover"
                                                     @click.stop="edit(slot.item, slot.index, $event.target)"></i>
                                    </b-col>
                                </b-row>
                                <p class="card-text">
                                    {{slot.item.user.email}} <br>
                                    {{slot.item.phone}}
                                </p>
                            </b-card-body>
                            <b-button-group class="buttons">
                                <b-button class="hover btn hover btn-outline-success" variant="default" :href="'/admin/agents/listings/' + slot.item.slug">Listings
                                </b-button>
                                <image-create @image-uploaded="imageUploaded" :message="'Add image'"
                                                :agent="slot.item"></image-create>
                                <b-button class="delete hover btn hover btn-outline-danger" type="danger" variant="default"
                                          @click.stop="removeAgent(slot.item)">Remove
                                </b-button>
                            </b-button-group>
                        </b-card>
                    </template>
                </vue-chunks>
            </b-card>
            <b-row class="mt-4 text-center">
                <b-col>
                    <div class="overflow-auto mt-2">
                        <b-pagination
                            v-model="pagination.current_page"
                            :total-rows="total"
                            align="center"
                            :per-page="per_page"
                            aria-controls="results"
                        ></b-pagination>
                    </div>
                </b-col>
            </b-row>
            <!-- Loading element -->
            <div id="loading" class="loading" v-if="isLoading">
                <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                <span class="sr-only">Loading...</span>
            </div>
            <!-- Modals -->
            <b-modal id="editModal" ref="editModal" title="Edit Agent" size="lg">
                <agent-edit ref="editAgent" :agent="this.agent" :editing="true"></agent-edit>
                <div slot="modal-footer" class="w-100"></div>
            </b-modal>

            <b-modal id="createModal" ref="createModal" title="Create Agent" size="lg">
                <agent-edit ref="createAgent"></agent-edit>
                <div slot="modal-footer" class="w-100"></div>
            </b-modal>
        </b-container>
    </div>
</template>

<script>

export default {
    name: 'agents-list',

    // components: {VImageCreate, AgentEdit},

    data() {
        return {
            breadcrumb_items: [
                {
                    'text': 'Home',
                    'href': "/"
                },
                {
                    'text': "My Dashboard",
                    'href': "/admin/dashboard"
                },
                {
                    'text': "Edit Agents",
                    'href': "#"
                },
            ],
            value: "",
            show: false,
            isLoading: false,
            agents: [],
            perPage: 25,
            pagination: {
                current_page: null,
                total: null,
                from: null,
                per_page: null
            },
            agent: {
                phone: "",
                user: {
                    name: "",
                    email: "",
                    admin: null,
                }
            }
        }
    },
    created() {
        this.getAgentData();
    },
    methods: {
        removeAgent(agent) {
            let _self = this;
            this.$dialog
                .confirm('Really remove agent?')
                .then(function (dialog) {
                    let data = {
                        agentId: agent.id,
                    };
                    _self.isLoading = true;
                    axios.post('/api/agents/destroy', data)
                        .then(function (response) {
                            _self.isLoading = false;
                            if (response.data.status !== true) {
                                _self.$eventHub.$emit('app::message', 'error', 'Error', "This agent could not be deleted");
                            } else {
                                _self.$eventHub.$emit('app::message', 'success', 'Success', "Agent deleted!");
                                location.reload();
                            }
                        });
                });
        },
        edit_picture(agent) {
            this.agent = agent;
            this.$refs['imageModal'].show();
        },
        imageUploaded(imgSrc, agent) {
            let _self = this;
            _self.isLoading = true;
            _self.agent = agent;
            let data = {
                file: imgSrc,
                agent: this.agent
            };

            let config = {
                header: {
                    'Content-Type': 'image/png'
                }
            };

            axios.post('/api/agents/addImage', data, config)
                .then(function (response) {
                    _self.isLoading = false;

                    if (response.data.status === false) {
                        _self.toast('Error adding image', 'danger');
                    } else {
                        _self.toast('image Added!', 'success');
                        location.reload()
                    }
                });
        },
        getAgentData(page = 1) {
            let _self = this;
            _self.isLoading = true;

            let data = {
                params: {
                    page: page,
                    sortOrder: 'DESC'
                }
            };

            let promise = axios.get('/api/agents', data);
            // Must return a promise that resolves to an array of items
            return promise.then((response) => {

                if (typeof response !== 'undefined' && response !== null) {
                    _self.agents = $.map(response.data.agents, function (dataItem) {
                        return dataItem;
                    });

                    _self.pagination = response.data.pagination;
                    _self.isLoading = false;
                }
            });
        },
        edit(agent, index) {
            this.agent = agent;
            this.$refs['editModal'].show();
        },
        create() {
            this.$refs['createModal'].show();
        },
        agent_updated() {
            this.$refs['editModal'].hide();
            this.toast('Agent Updated!', 'success');
        },
        agent_created() {
            this.$refs['createModal'].hide();
            this.toast('Agent Created!', 'success');
            location.reload();
        },
        agent_deleted() {
            this.$refs['editModal'].hide();
            this.toast('Agent Deleted', 'success');
        },
        toast(message, variant) {
            this.$bvToast.toast(message, {
                title: variant,
                variant: variant,
                solid: true
            })
        }
    },
    mounted() {
        this.$eventHub.$on('listing::added', this.listed_added);
        this.$eventHub.$on('agent::updated', this.agent_updated);
        this.$eventHub.$on('agent::created', this.agent_created);
        this.$eventHub.$on('agent::deleted', this.agent_deleted);
    },
    computed: {
        total() {
            return this.pagination.total
        },
        current_page() {
            return this.pagination.current_page
        },
        per_page() {
            return this.pagination.per_page
        }
    },
    watch: {
        current_page: function (val) {
            this.getAgentData(val);
        }
    }
}
</script>

<style>
.delete {
    color: red;
}

.card {
    height: 100%
}

h4 {
    display: inline-block; /* to make it inline */
}

.no-border {
    border: 0;
}

#loading {
    background: rgba(255, 255, 255, 0.6);
    position: fixed;
    height: 100vh;
    width: 100vw;
    z-index: 10010;
    top: 0;
    left: 0;
    text-align: center;
}

#loading i {
    Position: absolute;
    Top: 50%;
    Transform: translateY(-50%);
}

.no-border {
    border: 0;
}

.hover:hover {
    color: blue;
}
</style>
